module.exports = __webpack_public_path__ + "static/media/48.c78e2c31.jpg";